<div class="wrapper" [ngClass]="{'minimized-nav': minimizedNav}">
  <div class="topbar shadow-5">
    <div class="header">
      <i class="pi pi-align-justify" (click)="onMinimizedNavClicked()"></i>
      <span>E</span>
      <span>xternal</span>
      <span>&nbsp;</span>
      <span>T</span>
      <span>ransactions</span>
      <span>&nbsp;</span>
      <span>A</span>
      <span>dministration</span>
      <span>&nbsp;</span>
      <span>P</span>
      <span>ortal</span>
    </div>
    <login 
      [inactive]="inactiveStatus"
      (loginStatusChanged)="onLoginStatusChanged($event)"
      (commonAccessChanged)="onCommonAccessChanged($event)"
      (adminAccessChanged)="onAdminAccessChanged($event)"></login>
  </div>
  
  <div class="content-wrapper">
    <div *ngIf="isLoggedIn" class="sidebar shadow-5">
      <div *ngIf="isCommon">
        <input type="checkbox" id="cb1" name="menu-item-group" [value]="COMMON_REQUESTS"  [checked]="this.activePath.includes('/common/')"/>
        <label for="cb1">
          <i class="pi pi-chevron-right"></i>
          <span>Common Requests</span>
        </label>
        <ul class="menu-list ml-3">
          <li class="menu-item" [class.active]="this.activePath.includes('/common/unit-status')" routerLink="/common/unit-status">
            <i class="pi pi-exclamation-circle menu-item-icon"></i>
            <span class="menu-item-text">Unit Status</span>
            <span class="tooltip">Unit Status</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/resend-ucm')" routerLink="/common/resend-ucm">
            <i class="pi pi-sort-alt menu-item-icon"></i>
            <span class="menu-item-text">Resend UCM</span>
            <span class="tooltip">Resend UCM</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/cancel-contract')" routerLink="/common/cancel-contract">
            <i class="pi pi-times menu-item-icon"></i>
            <span class="menu-item-text">Cancel Contract / Test Activation</span>
            <span class="tooltip">Cancel Contract / Test Activation</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/transfer-contract')" routerLink="/common/transfer-contract">
            <i class="pi pi-arrow-circle-right menu-item-icon"></i>
            <span class="menu-item-text">Transfer Contract</span>
            <span class="tooltip">Transfer Contract</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/edit-contract')" routerLink="/common/edit-contract">
            <i class="pi pi-pencil menu-item-icon"></i>
            <span class="menu-item-text">Edit Contract</span>
            <span class="tooltip">Edit Contract</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/customer-support-activation')" routerLink="/common/customer-support-activation">
            <i class="pi pi-phone menu-item-icon"></i>
            <span class="menu-item-text">Customer Support Activation</span>
            <span class="tooltip">Customer Support Activation</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/audit-trail')" routerLink="/common/audit-trail">
            <i class="pi pi-list menu-item-icon"></i>
            <span class="menu-item-text">Audit Trail / Transaction Log</span>
            <span class="tooltip">Audit Trail / Transaction Log</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/common/reports')" routerLink="/common/reports">
            <i class="pi pi-chart-bar menu-item-icon"></i>
            <span class="menu-item-text">Reports</span>
            <span class="tooltip">Reports</span>
          </li>
        </ul>
      </div>

      <div class="" *ngIf="isAdmin">
        <input type="checkbox" id="cb2" name="menu-item-group" [value]="ADMIN_FUNCTIONS" [checked]="this.activePath.includes('/admin/')"/>
        <label for="cb2">
          <i class="pi pi-chevron-right"></i>
          <span>Admin Functions</span>
        </label>
        <ul class="menu-list ml-3">
          <li class="menu-item" [class.active]="this.activePath.includes('/admin/internal-users')" routerLink="/admin/internal-users">
            <i class="pi pi-users menu-item-icon"></i>
            <span class="menu-item-text">Internal Users</span>
            <span class="tooltip">Internal Users</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/admin/system-configuration')" routerLink="/admin/system-configuration">
            <i class="pi pi-cog menu-item-icon"></i>
            <span class="menu-item-text">System Configuration</span>
            <span class="tooltip">System Configuration</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/admin/topcon-configuration')" routerLink="/admin/topcon-configuration">
            <i class="pi pi-cog menu-item-icon"></i>
            <span class="menu-item-text">Topcon Configuration</span>
            <span class="tooltip">Topcon Configuration</span>
          </li>
          <li class="menu-item" [class.active]="this.activePath.includes('/admin/partner-configuration')" routerLink="/admin/partner-configuration">
            <i class="pi pi-cog menu-item-icon"></i>
            <span class="menu-item-text">Partner Specific Configuration</span>
            <span class="tooltip">Partner Specific Configuration</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <p-menu #menu [popup]="true" [model]="items"></p-menu>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
</div>